<template>
  <div id="view-page" align="center">
    <loader_component v-if="is_loading" />
    <div v-else>
      <div v-if="media == 'image'">
        <div v-if="Array.isArray(file) && media == 'image'">
          <img
            v-for="(img, index) in file"
            :src="img"
            :key="index"
            style="cursor: pointer"
            @click="toFile(img)"
            width="75%"
          />
        </div>
        <img
          v-else
          :src="file"
          style="cursor: pointer"
          @click="toFile(file)"
          width="50%"
          :alt="file"
        />
      </div>
      <video
        v-if="media == 'video'"
        @error="videoError"
        style="height: 100%"
        controls
        type="video/mp4"
        :src="file"
      >
        Your browser does not support HTML5 video.
      </video>
      <div v-if="media == 'news' && dataStream" class="container">
        <div class="card rounded responsive">
          <div class="card-header mb-2 image-container">
            <img :src="dataStream.thumbnail" class="rounded img-responsive" />
            <span class="image-caption">
              <i class="bi bi-globe-americas"></i>
              {{ dataStream.account }}
              <i class="bi bi-person ml-3"></i>
              {{ dataStream.journalist ? dataStream.journalist : "-" }}
            </span>
          </div>
          <div class="card-body">
            <div class="h6 font-weight-bolder text-justify">
              {{ dataStream.title }}
            </div>
            <p
              class="mt-3 scroller text-justify"
              style="max-height: 45vh"
              v-html="writeContent(dataStream.content)"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader_component from "@/views/components/loader.vue";

export default {
  name: "View",
  components: {
    loader_component,
  },
  title: "Archive Online Media Monitoring",
  data() {
    return {
      is_loading: true,
      file: this.$route.query.file,
      media: this.$route.query.media,
      file_src: this.$route.query.src,
      file_error: false,
      id: this.$route.query.id,
      spaces_domain: "https://dev-kurasi.nyc3.digitaloceanspaces.com/jpgs/",
      dataStream: {},
    };
  },
  methods: {
    getStream: function () {
      this.is_loading = true;
      let api = process.env.VUE_APP_API_URL + "stream/" + this.id;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.dataStream = response.data;
            if (Array.isArray(this.dataStream.file_source)) {
              this.file = this.dataStream.file_source;
            } else {
              if (
                this.dataStream.source == "media_cetak" ||
                this.dataStream.source == "media_tv"
              ) {
                if (this.dataStream.file_source.includes("http")) {
                  this.file = this.dataStream.file_source;
                } else {
                  this.file = this.spaces_domain + this.dataStream.file_source;
                }
              }
            }
            if (this.dataStream.source == "media_cetak") {
              this.media = "image";
            } else if (this.dataStream.source == "media_tv") {
              this.media = "video";
            } else if (this.dataStream.source == "news") {
              this.media = "news";
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    videoError: function () {
      if (!this.file_error) {
        let filepart = this.file.split("/");
        let filename = filepart[filepart.length - 1];
        filepart = filename.split("-");
        let domain;
        if (this.media == "video") {
          domain = "https://input.digivla.id/media_tv/";
        } else {
          domain = "http://pdf.antara-insight.id/pdf_images/";
        }

        let file_src =
          domain +
          filepart[0] +
          "/" +
          filepart[1] +
          "/" +
          filepart[2] +
          "/" +
          filename;
        this.file = file_src;
        this.file_error = true;
      } else {
        alert("file not found");
      }
    },
    writeContent: function (text) {
      var newText = text;
      newText = newText.replace(/\n/g, "<br />");
      return newText;
    },
    toFile: function (src) {
      window.open(src, "_blank");
    },
  },
  created: function () {
    if (this.id) {
      this.getStream();
    } else if (this.file_src) {
      try {
        let file_obj = JSON.parse(atob(this.file_src));
        this.media = file_obj["media"];
        if (this.media == "video") {
          this.file = file_obj["file"];
        } else {
          if (Array.isArray(file_obj["file"])) {
            this.file = file_obj["file"];
          } else {
            if (file_obj["file"].includes("http")) {
              this.file = file_obj["file"];
            } else {
              this.file = this.spaces_domain + file_obj["file"];
            }
          }
        }
      } catch (e) {
        this.file = "";
        this.media = "gambar";
        alert("file not found");
      }
    }
  },
};
</script>
<style scoped>
.responsive {
  width: 60%;
  padding-left: 1rem;
  padding-right: 1rem;
}
.img-responsive {
  margin-top: 20px;
  width: 100%;
  max-height: 20rem;
  object-fit: cover;
  overflow: hidden;
  filter: brightness(50%);
}
.image-container {
  position: relative;
  display: inline-block;
}
.image-caption {
  position: absolute;
  bottom: 10px;
  left: 0;
  color: white;
  padding: 10px 40px 10px 40px;
  font-size: 16px;
  text-align: left;
  width: 100%;
}
@media (max-width: 768px) {
  .responsive {
    width: 100%;
  }
  .image-caption {
    font-size: 14px;
  }
}
</style>
